import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";
import ConfigProvider from "./config/ConfigProvider";
import { pdfjs } from "react-pdf";
import { AppFrame } from "./AppFrame";
import { theme } from "./theme";
import { routes } from "./AuthedRoute";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto-condensed/400.css";
import "@fontsource/roboto-condensed/700.css";
import "./index.css";
import "./message-board/print.css";
import "./calendar/style.css";
import axios from "axios";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { UseLayoutProvider } from "./layout/use-layout-mode";
import { APP_VERSION } from "./config/app-version";

axios.defaults.headers.common["x-app-version"] = `web/${APP_VERSION}`;

pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.mjs`;

const queryClient = new QueryClient();

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <UseLayoutProvider>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider autoHideDuration={4000}>
            <ConfigProvider>
              <CssBaseline />
              <AppFrame>
                <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="en-gb">
                  <RouterProvider
                    router={router}
                    future={{
                      v7_startTransition: true,
                    }}
                  />
                </LocalizationProvider>
              </AppFrame>
            </ConfigProvider>
          </SnackbarProvider>
        </QueryClientProvider>
      </UseLayoutProvider>
    </ThemeProvider>
  </React.StrictMode>
);
